import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 获取列表
export function searchLogList(data) {
  return request({
    url: URL.sys.searchLogList,
    method: 'post',
    data
  })
}
